import Papa from 'papaparse';

const ExportCSV = cb => async data => {
  const config = {
    quotes: false,
    quoteChar: '"',
    escapeChar: '"',
    delimiter: ',',
    header: true,
    newline: '\r\n',
    skipEmptyLines: false, // or 'greedy',
    columns: null, // or array of strings
  };

  const keys = Object.keys(data);
  const values = Object.values(data);

  const link = document.createElement('a');

  const csv = await Papa.unparse(
    {
      fields: ['', ''],
      data: keys.map((d, index) => [
        d.toUpperCase().replace('_', ' '),
        values[index],
      ]),
    },
    config,
  );
  const blob = new Blob([csv], {
    encoding: 'UTF-8',
    type: 'text/csv;charset=utf-8;',
  });

  const download = URL.createObjectURL(blob);
  link.href = download;
  link.download = `${data.nome}.csv`;
  link.click();
  cb(prev => !prev);
};

export default ExportCSV;
